import { employeeMngtReducer } from "./employeemanagement/employee.reducers";
import { orgarnizationMngtReducer } from "./organizationmanagement/orgarnization.reducers";
import { holidaysMngtReducer } from "./holidaymanagement/holiday.reducers";
import { muchAndLearnMngtReducer } from "./trainingmanagement/training.reducers";
import { notificationsReducer } from "./notifications/notification.reducer";
import { reportingReducer } from "./reportingmanagement/reporting.reducers";
import { systemConfigReducer } from "./systemconfiguration/systemconfig.reducer";
import { performanceMngtReducer } from "./performancemanagement/performance.reducer";
import { activityLogsReducer } from "./activitylogs/activitylog.reducer";

const AllReducers = {
  orgarnizationMngt: orgarnizationMngtReducer,
  employeeMngt: employeeMngtReducer,
  holidaysMngt: holidaysMngtReducer,
  trainingMngt: muchAndLearnMngtReducer,
  notifications: notificationsReducer,
  reporting: reportingReducer,
  systemConfig: systemConfigReducer,
  performanceMngt: performanceMngtReducer,
  activitylogs: activityLogsReducer,
};

export default AllReducers;



// WEBPACK FOOTER //
// ./src/store/actions/index.js